import { Link, useHistory } from "react-router-dom";

import HeaderWebb from "../comp/head-navs-webb";
import ViewContentSmall from "../comp/view-content-sm";
import ViewDividerSmall from "../comp/view-divider-sm";
import ViewDividerMedium from "../comp/view-divider-md";
import ViewSectionName from "../comp/view-section-name";

import WebbSearchModule from "../comp/webb-search";

export default function Search() {

  const history = useHistory();


  return (
    <>
    <HeaderWebb/>

    <ViewContentSmall 
        content={
          <>
            <div className="text-center">
              <ViewDividerSmall />
              <p>Search for Delivery Partners, Agents and Shipment</p>
            </div>
            <ViewDividerSmall />
            <WebbSearchModule />

            <ViewDividerMedium />
            <ViewDividerMedium />
          </>
        }
      />

    <ViewDividerMedium />
    <ViewDividerMedium />
    </>
  )
}